import React from 'react';
import Footer from '../../components/footer/Footer';
import Navbar from '../../components/navigation/Navbar';
import './htmlCours.css';

function HtmlCours() {
    return (
        <>
            <Navbar />

            <h1>Introduction au HTML</h1>
            <h2>I. Les fondamentaux du HTML</h2>
            <p>Structure de base d'une page HTML :</p>
            <pre>
                &lt;!DOCTYPE html&gt;
                &lt;html&gt;
                &lt;head&gt;
                &lt;title&gt;Titre de la page&lt;/title&gt;
                &lt;/head&gt;
                &lt;body&gt;
                {/* Contenu de la page */}
                &lt;/body&gt;
                &lt;/html&gt;
            </pre>
            <h2>II. Les balises de texte</h2>
            <p>Exemples de balises de texte :</p>
            <h1>Titre de niveau 1</h1>
            <p>Paragraphe de texte.</p>
            <a href="https://www.example.com">Lien hypertexte</a>
            <strong>Texte en gras</strong>
            <em>Texte en italique</em>
            <br /> (saut de ligne)
            <hr /> (ligne horizontale)
            <h2>III. Les balises de structure</h2>
            <p>Exemples de balises de structure :</p>
            <div>Contenu divisé</div>
            <span>Conteneur inline</span>
            <header>En-tête</header>
            <footer>Pied de page</footer>
            <nav>Navigation</nav>
            <section>Section</section>
            <h2>IV. Les images et les médias</h2>
            <p>Exemple d'inclusion d'image :</p>
            <img
                src="chemin/vers/image.jpg"
                alt="Description de l'image"
                title="Info-bulle au survol de l'image"
            />
            <h2>V. Les formulaires</h2>
            <p>Exemple de formulaire :</p>
            <form action="traitement.php" method="post">
                <label htmlFor="nom">Nom :</label>
                <input type="text" id="nom" name="nom" required /><br />
                <label htmlFor="email">Email :</label>
                <input type="email" id="email" name="email" required /><br />
                <input type="submit" value="Envoyer" />
            </form>
            <h2>VI. Les tableaux</h2>
            <p>Exemple de tableau :</p>
            <table>
                <thead>
                    <tr>
                        <th>Entête 1</th>
                        <th>Entête 2</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Donnée 1</td>
                        <td>Donnée 2</td>
                    </tr>
                </tbody>
            </table>
            <h2>VII. Les feuilles de style CSS</h2>
            <p>Liaison du CSS au HTML :</p>
            <style>
                {/* Styles CSS peuvent être ajoutés ici */}
            </style>
            <link rel="stylesheet" href="style.css" />
            <h2>VIII. Les bonnes pratiques et les ressources supplémentaires</h2>
            <p>Pour valider le code HTML :</p>
            <p>Utilisez le validateur W3C : <a href="https://validator.w3.org/">https://validator.w3.org/</a></p>
            <p>Ressources supplémentaires :</p>
            <ul>
                <li>Documentation en ligne (MDN, W3Schools)</li>
                <li>Forums et communautés pour poser des questions</li>
            </ul>

            <Footer />
        </>
    );
}

export default HtmlCours;
